import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import PermissionAdapter from "../../../adapters/PermissionAdapter";

export default class GetBackofficeUsersResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "users": [
                    {
                        'user': {
                            'email': 'michael@dundermifflin.com'
                        },
                        'delivery_site_user_roles': [],
                        'permissions': ["USER_PERMISSION", "ORDER_PERMISSION", "CURRENT_ACCOUNT_PERMISSION", "CREATE_ORDER_PERMISSION"]
                    }
                ]
            },
            errors: []
        }
    }

    users() {
        return this.content().users.map(userWithPermissions => {
            const permissions = userWithPermissions.permissions.map(permission => this._adaptPermission(permission));

            return {
                userEmail: userWithPermissions.user.email,
                permissions: this._adaptListWithoutRepetitions(permissions),
            }
        })
    }

    _adaptListWithoutRepetitions(aList){
        return this._adaptList(this._withoutRepetitions(aList))
    }

    _withoutRepetitions(aListOfElements) {
        return [...new Set(aListOfElements)]
    }

    _adaptList(aList) {
        return aList.join(", ")
    }

    _adaptPermission(permission) {
        return new PermissionAdapter(permission).adapt()
    }
}
